export default "__VITE_PUBLIC_ASSET__52c55935__"